import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { PinIcon, LockIcon, TopCommentIcon } from '../../components/icons';
import MoreButton from '../../components/more-button';
import PostTitle from '../../components/post-title';
import TimeAgo from '../../components/time-ago';
import UserAvatarImage from '../../components/user-avatar-image';
import IconTooltip from '../../components/icon-tooltip';
import PostActions from '../../containers/post-actions';
import { getCategory } from '../../selectors/categories-selectors';
import withFontClassName from '../../hoc/with-font-class-name';
import withEnvironment from '../../hoc/with-environment';
import withTopCommentColor from '../../hoc/with-top-comment-color';
import withExperiment from '../../hoc/with-experiment';
import withTranslate from '../../hoc/with-translate';
import { EXPERIMENT_TOP_COMMENT } from '../../constants/experiments';
import styles from './post-list-item-classic.scss';

export const PostListItemClassic = ({
  type,
  category,
  post,
  query,
  titleFontClassName,
  contentFontClassName,
  navigation: { ProfileLink, Link },
  topCommentColor,
  isTopCommentExperimentEnabled,
  t,
}) => {
  const className = classNames(styles.container, 'forum-text-color', 'post-list-item', contentFontClassName);
  const owner = post.owner || {};
  const moreButtonId = `more-button-${post._id}`;
  return (
    <tr className={className}>
      <td className={styles.avatar}>
        <ProfileLink className={styles.avatarLink} user={owner} >
          <UserAvatarImage user={owner}/>
        </ProfileLink>
      </td>
      <td>
        <div className={styles.titleWrapper}>
          <Link className={classNames(titleFontClassName, styles.titleLink)} to={`/${category.slug}/${post.slug}`}>
            <PostTitle
              className={classNames(titleFontClassName, styles.title)}
              type={type}
              title={post.title}
              query={query}
            />
          </Link>
          {post.isPinned &&
            <PinIcon className={classNames(styles.icon, 'icon-secondary-fill')} isPinned={post.isPinned}/>}
          {post.isCommentsDisabled &&
            <LockIcon className={classNames(styles.icon, 'icon-secondary-fill')} isLocked={post.isCommentsDisabled}/>}
          {isTopCommentExperimentEnabled && Boolean(post.topCommentId) &&
            <IconTooltip text={t('comment.top-comment')} className={styles.tooltip}>
              <TopCommentIcon color={topCommentColor}/>
            </IconTooltip>}
        </div>
        <ProfileLink className={classNames(styles.name, 'forum-text-color')} user={owner}>
          {owner.name},&nbsp;
        </ProfileLink>
        <TimeAgo className={styles.timeAgo} time={post.createdDate}/>
      </td>
      <td className={classNames(styles.stats, styles.count, styles.right)}>
        {post.viewCount || 0}
      </td>
      <td className={classNames(styles.stats, styles.count, styles.right)}>
        {post.totalComments || 0}
      </td>
      <td className={classNames(styles.stats, styles.count, styles.right)}>
        {post.likeCount || 0}
      </td>
      <td className={classNames(styles.stats, styles.left, styles.recentActivity)}>
        <TimeAgo time={post.lastActivityDate || post.createdDate}/>
      </td>
      <td className={classNames(styles.more)}>
        <MoreButton id={moreButtonId}>
          <PostActions post={post} focusOnCloseId={moreButtonId}/>
        </MoreButton>
      </td>
    </tr>
  );
};

PostListItemClassic.propTypes = {
  t: PropTypes.func,
  category: PropTypes.object,
  post: PropTypes.object.isRequired,
  query: PropTypes.string,
  type: PropTypes.string,
  titleFontClassName: PropTypes.string,
  contentFontClassName: PropTypes.string,
  navigation: PropTypes.object,
  topCommentColor: PropTypes.string,
  isTopCommentExperimentEnabled: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  category: getCategory(state, ownProps.post.categoryId),
});

export default flowRight(
  connect(mapStateToProps),
  withEnvironment({ navigation: 'navigation' }),
  withFontClassName,
  withTopCommentColor,
  withTranslate,
  withExperiment({ isTopCommentExperimentEnabled: EXPERIMENT_TOP_COMMENT }),
)(PostListItemClassic);



// WEBPACK FOOTER //
// ./app/components/post-list-item-classic/post-list-item-classic.js